import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeart = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 57",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M29.89 9.7a24.04 24.04 0 0 0-3.4-4.43c-.49-.5-1.4-.47-1.9-.87-.64-.5-.85-1.41-1.49-1.78-6.6-3.75-13.23-.2-16.2 1.2-1.32.63-2.83 1.98-4.1 3.92-.51.76-.5 1.42-.9 2.36-.32.75-1.08 1.75-1.3 2.6-.97 3.65-.9 8.17 1.3 13.17a22 22 0 0 0 .94 1.86c.38.68 1.46 1.06 2.12 1.93.46.6.56 1.73 1.4 2.62 1.44 1.53 4.34 3.55 9.06 7.85.34.3.87 1.52 1.23 1.84.52.47.9 1.69 1.59 2.31.29.26 1.43.67 1.82 1.03 1.4 1.24 4.55 5 9.83 9.57.69.6 1.85 1.27 3.5 2.03 1.3-.91 2.15-1.59 2.57-2.03.45-.47 1.48-1.65 1.91-2.12.36-.39 1.07-2.3 1.42-2.68 4.04-4.44 6.44-8.22 9.2-11.78.32-.42 1.61-1 1.92-1.41.3-.4 1.64-2.33 1.92-2.72 4.99-6.83 6.54-10.72 7.39-15.84.57-3.4.27-7.36-.85-9.3-.25-.45-.84-1.93-1.15-2.42-.98-1.55-1.78-3.65-4.1-4.47C51.6 1.4 50.65.54 49.42.26c-2.52-.58-4.16 0-4.36 0-1.65 0-3.7.35-5.76.86-6.27 1.55-7.74 5.82-9.4 8.58Z",
		fill: "#BA55D3"
	})
});
export default SvgHeart;
